export function messageToWebview(action: string, parameters?: Record<string, unknown>) {
  window.ReactNativeWebView?.postMessage(
    encodeURIComponent(
      JSON.stringify({
        action,
        parameters,
      }),
    ),
  );
}
